import React from 'react'
import "./OurTeam.css"
import { Hero } from '../../Components'
import { AboutTeam } from '../../Features/OurTeam'

const OurTeam = ({url, data, translations}) => {

  const teamSection = data?.find(item => item.section === "Team Section");
  const contactSection = data?.find(item => item.section === "Contact Us Section");

  return (
    <div>
        <Hero
            mainTitle={"Home /"}
            title={translations?.message?.aboutUs ? translations.message.aboutUs :"About us" + " / "+translations?.message?.ourTeam ? translations.message.ourTeam :"Our Team"}
            para={translations?.message?.ourTeam ? translations.message.ourTeam :"Our Team"}
        />
        <AboutTeam  url={url} teamSection={teamSection} contactSection={contactSection} translations={translations} />
    </div>
  )
}

export default OurTeam